type PutFileOptions = {
  url: string
  file: File
  mimeType: string
  onProgress: (percent: number) => void
  signal?: AbortSignal
}

/** Uploads bytes to a presigned URL with progress; rejects on failure or abort. */
export function putFile({
  url,
  file,
  mimeType,
  onProgress,
  signal,
}: PutFileOptions) {
  return new Promise<void>((resolve, reject) => {
    const request = new XMLHttpRequest()
    const abort = () => {
      request.abort()
      reject(new DOMException('Upload cancelled', 'AbortError'))
    }
    if (signal?.aborted) {
      abort()

      return
    }
    signal?.addEventListener('abort', abort, { once: true })
    request.open('PUT', url)
    request.setRequestHeader('Content-Type', mimeType)
    request.upload.onprogress = (event) => {
      if (event.lengthComputable)
        onProgress(Math.round((event.loaded / event.total) * 100))
    }
    request.onload = () => {
      signal?.removeEventListener('abort', abort)
      if (request.status >= 200 && request.status < 300) resolve()
      else reject(new Error('Object upload failed'))
    }
    request.onerror = () => {
      signal?.removeEventListener('abort', abort)
      reject(new Error('Object upload failed'))
    }
    request.send(file)
  })
}
